import axios from 'axios';
// import store from './store.js';

const gotoLoginPage = () => {
    const redirectionUrl = process.env.VUE_APP_SALESFORCE_REDIRECT_URL.replace('{{HOST}}', window.location.host);
    window.location.href = redirectionUrl;
}

const Instance = () => {
    const instance = axios.create({
        baseURL: '/api/',
        headers: {
            'Content-Type': 'application/json',
            // 'Authorization': store.getters['user/token']
        }
    })
    instance.interceptors.response.use(function (response) {
        // Any status code that lie within the range of 2xx cause this function to trigger
        // Do something with response data
        return response;
      }, function (error) {
        // Any status codes that falls outside the range of 2xx cause this function to trigger
        // Do something with response error
        if(error.response.status == 401) {
            gotoLoginPage();
        }
        return Promise.reject(error);
      });
    return instance;
};

const upload = (url, formData) => {
    axios.interceptors.response.use(function (response) {
        // Any status code that lie within the range of 2xx cause this function to trigger
        // Do something with response data
        return response;
      }, function (error) {
        // Any status codes that falls outside the range of 2xx cause this function to trigger
        // Do something with response error
        if(error.response.status == 401) {
            gotoLoginPage();
        }
        return Promise.reject(error);
      });
    return axios.post( `/api${url}`,
        formData,
        {
            headers: {
                'Content-Type': 'multipart/form-data',
                // 'Authorization': store.getters['user/token']
            }
        }
    )
}

export { upload };
export default Instance;
